import { Injectable } from '@angular/core';
import { AppUpdateState } from '../../state-stores/app-update.state';
import { SwUpdate } from '@angular/service-worker';
import { interval } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppUpdateService {
  constructor(private swUpdate: SwUpdate, private appUpdateState: AppUpdateState) {}

  public startCheckingForUpdates() {
    if (this.swUpdate.isEnabled) {
      this.checkForUpdates();
      // Check every 1 minute (60000 ms)
      interval(1 * 60 * 1000).subscribe(() => {
        this.checkForUpdates();
      });
    }
    else{
      console.log('Service Worker is not enabled.');
    }
  }

  checkForUpdates() {
    this.swUpdate.checkForUpdate().then(hasUpdate => {
      if (hasUpdate) {
        this.appUpdateState.showUpdateBanner();
      }
    });
  }
}
